import { getOr } from 'lodash/fp';

interface EmptyObject {
    [key: string]: never;
}

export const getOrEmptyObject = getOr<EmptyObject>({});
